export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7747.aa6e2ba6.jpg";